import React from 'react';

const Table = ({ headers, data, classList }) => {
  const filteredData = data.filter((row) => !(['', undefined, null].includes(row)));

  const handleClassList = () => {
    if (!classList) {
      return ('table-container mb-6 col-md-8 col-12')
    } else {
      return classList;
    }
  }

  return (
    <div className={handleClassList()}>
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th className="text-nowrap"># out of {filteredData.length}</th>
            <th className="col-md-9">{headers}</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, idx) => (
            <tr key={`${row}-${idx}`}>
              <td style={{ width: '15%' }}>{ idx + 1 }</td>
              <td className="col-md-2">{row}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
